import React, {Component} from 'react';
import {Grid, Row, Col, Tabs, Tab} from "react-bootstrap";
import TopBreadcumb from "../../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../../shared/sidebar/SubHeader";
import SidebarComponent from "../../../../shared/sidebar/SidebarComponent";
import Links from "../../../../utilities/linksConfig/Links";
import DefinicjaEkipyContainer from "./definicjaEkipy/DefinicjaEkipyContainer";
import PolaczenieEkipyContainer from "./polaczenieEkipy/PolaczenieEkipyContainer";
import PolaczenieEkipIPojazdowContainer from "./polaczenieEkipIPojazdow/PolaczenieEkipIPojazdowContainer";

export default class EkipyContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: 1,
        };
        this.changeActiveTab = this.changeActiveTab.bind(this)
    }

    renderContent(){
        if(this.state.activeTab === 1){
            return <DefinicjaEkipyContainer/>
        }
        else if(this.state.activeTab === 2){
            return <PolaczenieEkipyContainer/>
        }
        else{
            return <PolaczenieEkipIPojazdowContainer/>
        }
    }

    changeActiveTab(eventKey){
        this.setState({activeTab:eventKey})
    }

    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module)=>this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'EkipyContainer'}>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb links={[{addressUrl: '/konfiguracja', text: 'Konfiguracja'}, {
                                    addressUrl: '/konfiguracja/zarzadzanie-zasobami',
                                    text: 'Zarządzanie zasobami'
                                }, {addressUrl: '/konfiguracja/zarzadzanie-zasobami/ekipy', text: 'Ekipy'}]}/>
                                <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz} history={this.props.history}/>
                            </div>
                        </Col>
                        <Col sm={12}>
                            <Tabs defaultActiveKey={1} id="ekipy-tab" onSelect={this.changeActiveTab}>
                                <Tab eventKey={1} title="Definicja ekip" >
                                </Tab>
                                <Tab eventKey={2} title="Połaczenie ekip z kierowcami">
                                </Tab>
                                <Tab eventKey={3} title="Połaczenie ekip z pojazdami">
                                </Tab>
                            </Tabs>
                        </Col>
                        <Col sm={12}>
                            <div style={{marginTop:'15px'}}>
                            {this.renderContent()}
                            </div>
                        </Col>
                    </Row>
                </Grid>
            </SidebarComponent>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/zasobyConfig/ekipy/EkipyContainer.js